module.exports = __webpack_public_path__ + "static/media/sign.dbadfb44.jpg";